import axios from "axios";
import { authHeader } from "./authHeader";

const API_URL = process.env.REACT_APP_API_URL;


const getProductTemplates = (params) => {
    return axios.get(API_URL + '/api/product/template', {
        params: params,
        headers: authHeader()
    });
};

const addProductTemplate = async (formData) => {
    const response = await axios.post(API_URL + "/api/product/template", formData, {
        headers: authHeader()
    });
    return response;
};

const updateProductTemplate = async (id, formData) => {
    const response = await axios.put(API_URL + `/api/product/template/${id}`, formData, {
        headers: authHeader()
    });
    return response;
};

const deleteProductTemplate = async (id) => {
    const response = await axios.delete(API_URL + `/api/product/template/${id}`, {
        headers: authHeader()
    });
    return response;
};

const getProductTemplatesById = async (l_id) => {
    const response = await axios.get(API_URL + `/api/product/template/${l_id}`, {
        headers: authHeader()
    });
    return response;
};

const PRODUCTTEMPLATEAPI = {
    getProductTemplates,
    addProductTemplate,
    updateProductTemplate,
    deleteProductTemplate,
    getProductTemplatesById
};

export default PRODUCTTEMPLATEAPI;

